import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, useTheme } from '@mui/material/styles';
const QrWrap = styled('div')(({ color }) => ({
    position: 'relative',
    display: 'inline-block',
    padding: 8,
    borderRadius: 8,
    '--ray-color': color,
    /* Base style for each line segment */
    '& .ray': {
        position: 'absolute',
        width: 10,
        height: 2,
        background: 'var(--ray-color)',
        pointerEvents: 'none',
        opacity: 0.95,
    },
    /* LEFT SIDE — positioned to the left of the QR */
    '& .left': { left: -20 },
    '& .left.top': { top: 'calc(50% - 18px)', transform: 'rotate(225deg)' },
    '& .left.mid': { top: '50%', transform: 'rotate(180deg)', left: -33, width: 20 },
    '& .left.bot': { top: 'calc(50% + 18px)', transform: 'rotate(135deg)' },
    /* RIGHT SIDE — positioned to the right of the QR */
    '& .right': { right: -20 },
    '& .right.top': { top: 'calc(50% - 18px)', transform: 'rotate(-45deg)' },
    '& .right.mid': { top: '50%', transform: 'rotate(0deg)', right: -33, width: 20 },
    '& .right.bot': { top: 'calc(50% + 18px)', transform: 'rotate(45deg)' },
}));
export default function WrapWithHightlight({ children, color }) {
    const theme = useTheme();
    return (_jsxs(QrWrap, { color: color || theme.palette.primary.main, children: [children, _jsx("div", { className: "ray left top" }), _jsx("div", { className: "ray left mid" }), _jsx("div", { className: "ray left bot" }), _jsx("div", { className: "ray right top" }), _jsx("div", { className: "ray right mid" }), _jsx("div", { className: "ray right bot" })] }));
}
